export default __webpack_public_path__ + "static/media/facebookIconWhite.7719fda0.svg";